import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LoginRecoveryFacade } from '@pages/login-recovery-options/facades/login-recovery.facade';
import { ForgotCompanyCredentials } from '@pages/login-recovery-options/models/forgot-company-credentials.interface';
import { TableTooltipComponent } from '@design/table/components/table-tooltip/table-tooltip.component';

@Component({
  selector: 'itc-recover-company-name-email-sent',
  templateUrl: 'recover-company-name-email-sent.component.html',
  styleUrl: 'recover-company-name-email-sent.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, TableTooltipComponent],
})
export class RecoverCompanyNameEmailSentComponent {
  private readonly loginRecoveryFacade = inject(LoginRecoveryFacade);

  readonly companyNameRecoveryCredentials = computed(() => this.loginRecoveryFacade.recoveryCredentials() as ForgotCompanyCredentials);
}
